import {FieldLabel} from '../../../FormSection'
import styles from '../../../../modalUnitConsumer.module.css'

type Field = {
  name: string
  label: string
  hint: string
  placeholder: string
  prefix?: string
  suffix?: string
}

const FIELDS: Field[] = [
  {
    name: 'energia_registrada_padrao',
    label: 'Energia registrada',
    hint: 'Total de energia consumida pela unidade (concessionária + créditos/usina)',
    placeholder: '0.0',
    suffix: 'kWh',
  },
  {
    name: 'energia_faturada_padrao',
    label: 'Energia faturada',
    hint: 'Total de energia consumida da concessionária (que foi cobrado na fatura)',
    placeholder: '0.0',
    suffix: 'kWh',
  },
  {
    name: 'tarifa_padrao',
    label: 'Tarifa',
    hint: 'Valor padrão da tarifa',
    placeholder: '0.00',
    prefix: 'R$',
  },
  {
    name: 'valor_faturado_padrao',
    label: 'Valor faturado',
    hint: 'Valor que foi cobrado pela concessionária na fatura',
    placeholder: '0.00',
    prefix: 'R$',
  },
]

const StepV2 = ({formik}: any) => {
  return (
    <div className={styles.fieldsGrid}>
      <div className={styles.fieldFull}>
        <FieldLabel
          htmlFor='uc_dia_padrao'
          hint='Dia em que a fatura da unidade é gerada (leitura)'
        >
          Dia da cobrança
        </FieldLabel>
        <input
          id='uc_dia_padrao'
          type='number'
          min={1}
          max={31}
          className='form-control form-control-solid'
          placeholder='Ex.: 10'
          value={formik.values.dia_padrão ?? ''}
          onChange={formik.handleChange('dia_padrão')}
          style={{maxWidth: '10rem'}}
        />
      </div>

      {FIELDS.map((field) => (
        <div key={field.name}>
          <FieldLabel htmlFor={`uc_${field.name}`} hint={field.hint}>
            {field.label}
          </FieldLabel>
          <div className='input-group input-group-solid'>
            {field.prefix && <span className='input-group-text'>{field.prefix}</span>}
            <input
              id={`uc_${field.name}`}
              type='text'
              inputMode='decimal'
              className='form-control form-control-solid'
              placeholder={field.placeholder}
              value={formik.values[field.name] ?? ''}
              onChange={formik.handleChange(field.name)}
            />
            {field.suffix && <span className='input-group-text'>{field.suffix}</span>}
          </div>
        </div>
      ))}
    </div>
  )
}
export {StepV2}
